import { defineClientComponent } from './src/js/clientComponents.ts';
import Component from './src/pages/sanity/page/ListPage/DrinkRecipes.tsx';
defineClientComponent('sanity/page/ListPage/DrinkRecipes', Component);